import { adminDashboards } from './AdminDashboards'
import { auth } from './Auth'
import { brands } from './Brands'
import { certificates } from './Certificates'
import { companies } from './Companies'
import { coupons } from './Coupons'
import { files } from './Files'
import { invoices } from './Invoices'
import { orders } from './Orders'
import { pillars } from './Pillars'
import { products } from './Products'
import { questions } from './Questions'
import { questionsAnswers } from './QuestionsAnswers'
import { signUp } from './SignUp'
import { topics } from './Topics'
import { userInvites } from './UserInvites'
import { users } from './Users'
import { configs } from './Configurations'

export default {
  adminDashboards,
  auth,
  brands,
  certificates,
  companies,
  coupons,
  files,
  invoices,
  orders,
  pillars,
  products,
  questions,
  questionsAnswers,
  signUp,
  topics,
  userInvites,
  users,
  configs
}
